@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;
@use '../../../../../components/Table/styles.module.scss' as Table;

.table-container__table__body {
	height: calc(100vh - Table.$var-company-header-height - Table.$var-breadcrumbs-header-height - Table.$var-tabs-navigation-height - Table.$var-table-header-height - Table.$var-table-action-header-height - Table.$var-table-footer-height - 4 * Constants.$val-spacing-xl - 6 * Constants.$val-spacing-m);
}

@mixin cell-text {
	font-size: Constants.$val-fontSizeSmall;
}

.linkCell{
	justify-content: space-between;
	color: Colors.$col-darkBlueBorder;
}

.panelHeader {
	background-color: Colors.$col-greyLight;
	color: Colors.$col-greyInactive;
	font-size: Constants.$val-fontSizeBig;
	font-weight: bold;
	display: flex; 
	justify-content: flex-start;
	align-items: center;
	height: 100%;
	padding: Constants.$val-spacing-m;
	
	.userName {
		color: Colors.$col-black;
		margin-left: Constants.$val-spacing-xs;
	}
}

.panelFooter {
	display: flex;
	background-color: Colors.$col-greyLight;
	color: Colors.$col-greyInactive;
	font-size: Constants.$val-fontSizeBig;
	justify-content: flex-end;
	gap: Constants.$val-spacing-m;
	height: 100%;
	padding: Constants.$val-spacing-m;
}

.fullName {
	text-transform: uppercase;
}

.deactivated {
	text-transform: uppercase;
	color: Colors.$col-greyInactive;
	margin-left: Constants.$val-spacing-xs;
}

.deactivatedIcon {
	text-transform: uppercase;
	color: Colors.$col-greyInactive;
	margin-left: Constants.$val-spacing-xs;
	font-size: Constants.$val-fontSizeXBig;
}

.filterButton {
	border: 1px solid Colors.$col-greyMid;
	border-radius: Constants.$val-borderRadius;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	display: flex;
	align-items: center;
	background: Colors.$col-white;
	width: Constants.$val-textFilterMinWidth;
}